export function compare(a: number | string, b: number | string) {
  if (typeof a !== typeof b) throw new Error("Invalid comparison types.");

  // comparison for number type.
  if (typeof a === "number" && typeof b === "number") return a - b;

  // comparison for string type.
  a = a ? a.toString() : "";
  b = b ? b.toString() : "";
  return a.localeCompare(b, "en", { sensitivity: "base" });
}
